<template>
  <div class="home">
    <Hero
      title="Faça parte da transformação <br /> do mundo Fitness"
      :image="'home-banner.png'"
      :search="true"
    />
    <Brands />
    <Job />
    <WayOfBeing />
    <WorkHere />
    <Faq />
  </div>
</template>

<script>
// @ is an alias to /src
import Hero from "@/components/media/Hero.vue";
import Slider from "@/components/media/Slider.vue";
import Gallery from "@/components/media/Gallery.vue";
import Faq from "@/components/Faq.vue";
//Components
import Brands from "@/views/home/components/Brands.vue";
import Job from "@/views/home/components/Job.vue";
import WayOfBeing from "@/views/home/components/WayOfBeing.vue";
import WorkHere from "@/views/home/components/WorkHere.vue";

export default {
  name: "Home",

  data() {
    return {
      sliderResponsive: {
        2000: {
          loop: false,
          items: 4,
          edgePadding: 130,
          nav: false,
          startIndex: 0,
        },

        1500: {
          loop: false,
          items: 4,
          edgePadding: 130,
          nav: false,
          startIndex: 0,
        },

        1400: {
          loop: false,
          items: 4,
          edgePadding: 130,
          nav: false,
          startIndex: 0,
        },

        1200: {
          loop: false,
          items: 4,
          edgePadding: 130,
          nav: false,
          startIndex: 0,
        },

        992: {
          loop: false,
          items: 3,
          edgePadding: 90,
          nav: false,
          startIndex: 0,
        },

        768: {
          loop: false,
          items: 2,
          edgePadding: 90,
          nav: true,
          startIndex: 0,
        },

        576: {
          loop: false,
          items: 2,
          edgePadding: 40,
          nav: true,
          startIndex: 0,
        },

        0: {
          loop: false,
          items: 1,
          edgePadding: 10,
          nav: true,
        },
      },

      sliderResponsive2: {
        2000: {
          loop: false,
          items: 4,
          edgePadding: 130,
          nav: false,
          startIndex: 0,
        },

        1500: {
          loop: false,
          items: 4,
          edgePadding: 170,
          nav: false,
          startIndex: 0,
        },

        1400: {
          loop: false,
          items: 4,
          edgePadding: 130,
          nav: false,
          startIndex: 0,
        },

        1200: {
          loop: false,
          items: 3,
          edgePadding: 130,
          nav: false,
          startIndex: 0,
        },

        992: {
          loop: false,
          items: 3,
          edgePadding: 90,
          nav: false,
          startIndex: 0,
        },

        768: {
          loop: false,
          items: 2,
          edgePadding: 90,
          nav: true,
          startIndex: 0,
        },

        576: {
          loop: false,
          items: 2,
          edgePadding: 40,
          nav: true,
          startIndex: 0,
        },

        0: {
          loop: false,
          items: 1,
          edgePadding: 40,
          nav: true,
        },
      },

      sliderResponsive3: {
        2000: {
          loop: false,
          items: 4,
          edgePadding: 130,
          nav: false,
          startIndex: 0,
        },

        1500: {
          loop: false,
          items: 4,
          edgePadding: 130,
          nav: false,
          startIndex: 0,
        },

        1400: {
          loop: false,
          items: 4,
          edgePadding: 130,
          nav: false,
          startIndex: 0,
        },

        1200: {
          loop: false,
          items: 4,
          edgePadding: 130,
          nav: false,
          startIndex: 0,
        },

        992: {
          loop: false,
          items: 3,
          edgePadding: 90,
          nav: false,
          startIndex: 0,
        },

        768: {
          loop: false,
          items: 3,
          edgePadding: 90,
          nav: true,
          startIndex: 0,
        },

        576: {
          loop: false,
          items: 2,
          edgePadding: 40,
          nav: true,
          startIndex: 0,
        },

        0: {
          loop: false,
          items: 2,
          edgePadding: 40,
          nav: true,
        },
      },
    };
  },

  head() {
    return this.$head({
      title: "",
    });
  },

  computed: {
    valores() {
      return this.$store.state.values;
    },

    teams() {
      return this.$store.state.teams;
    },

    conquistas() {
      return this.$store.state.conquistas;
    },

    faqItems() {
      return this.$store.state.faqItems;
    },
  },

  components: {
    Hero,
    Slider,
    Gallery,
    Faq,
    Brands,
    Job,
    WayOfBeing,
    WorkHere
  },

  mounted() {
    this.$store.dispatch("opportunities/setOpportunities");
  },
};
</script>

